import * as React from "react";
const SvgVertexAi = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20,13.89A.77.77,0,0,0,19,13.73l-7,5.14v.22a.72.72,0,1,1,0,1.43v0a.74.74,0,0,0,.45-.15l7.41-5.47A.76.76,0,0,0,20,13.89Z", style: {
  fill: "#669df6"
} }), /* @__PURE__ */ React.createElement("path", { d: "M12,20.52a.72.72,0,0,1,0-1.43h0v-.22L5,13.73a.76.76,0,0,0-1,.16.74.74,0,0,0,.16,1l7.41,5.47a.73.73,0,0,0,.44.15v0Z", style: {
  fill: "#aecbfa"
} }), /* @__PURE__ */ React.createElement("path", { d: "M12,18.34a1.47,1.47,0,1,0,1.47,1.47A1.47,1.47,0,0,0,12,18.34Zm0,2.18a.72.72,0,1,1,.72-.71A.71.71,0,0,1,12,20.52Z", style: {
  fill: "#4285f4"
} }), /* @__PURE__ */ React.createElement("path", { d: "M6,6.11a.76.76,0,0,1-.75-.75V3.48a.76.76,0,1,1,1.51,0V5.36A.76.76,0,0,1,6,6.11Z", style: {
  fill: "#aecbfa"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 5.98, cy: 12, r: 0.76, style: {
  fill: "#aecbfa"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 5.98, cy: 9.79, r: 0.76, style: {
  fill: "#aecbfa"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 5.98, cy: 7.57, r: 0.76, style: {
  fill: "#aecbfa"
} }), /* @__PURE__ */ React.createElement("path", { d: "M18,8.31a.76.76,0,0,1-.75-.76V5.67a.75.75,0,1,1,1.5,0V7.55A.75.75,0,0,1,18,8.31Z", style: {
  fill: "#4285f4"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 18.02, cy: 12.01, r: 0.76, style: {
  fill: "#4285f4"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 18.02, cy: 9.76, r: 0.76, style: {
  fill: "#4285f4"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 18.02, cy: 3.48, r: 0.76, style: {
  fill: "#4285f4"
} }), /* @__PURE__ */ React.createElement("path", { d: "M12,15a.76.76,0,0,1-.75-.75V12.34a.76.76,0,0,1,1.51,0v1.89A.76.76,0,0,1,12,15Z", style: {
  fill: "#669df6"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 16.45, r: 0.76, style: {
  fill: "#669df6"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 10.14, r: 0.76, style: {
  fill: "#669df6"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 7.92, r: 0.76, style: {
  fill: "#669df6"
} }), /* @__PURE__ */ React.createElement("path", { d: "M15,10.54a.76.76,0,0,1-.75-.75V7.91a.76.76,0,1,1,1.51,0V9.79A.76.76,0,0,1,15,10.54Z", style: {
  fill: "#4285f4"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 15.01, cy: 5.69, r: 0.76, style: {
  fill: "#4285f4"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 15.01, cy: 14.19, r: 0.76, style: {
  fill: "#4285f4"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 15.01, cy: 11.97, r: 0.76, style: {
  fill: "#4285f4"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 8.99, cy: 14.19, r: 0.76, style: {
  fill: "#aecbfa"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 8.99, cy: 7.92, r: 0.76, style: {
  fill: "#aecbfa"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 8.99, cy: 5.69, r: 0.76, style: {
  fill: "#aecbfa"
} }), /* @__PURE__ */ React.createElement("path", { d: "M9,12.73A.76.76,0,0,1,8.24,12V10.1a.75.75,0,1,1,1.5,0V12A.75.75,0,0,1,9,12.73Z", style: {
  fill: "#aecbfa"
} }));
export default SvgVertexAi;
